#!/usr/bin/env node

import minimist from 'minimist-lite';
import { ExtensionCreator } from './create/main';
import { ExtensionUpgrader } from './upgrade/main';
import { EslintUpgrader } from './eslint/main';
import { Angular15Upgrader } from './angular15/main';

const argv = minimist(process.argv.slice(2));

if (argv._[0] === 'upgrade') {
    const upgrader = new ExtensionUpgrader();
    upgrader.upgrade(
        argv.audit === undefined || argv.audit === 'true',
        process.cwd(),
        argv.experimental,
        argv.library,
        argv.internalOverride
    );
} else if (argv._[0] === 'create') {
    const creator = new ExtensionCreator(argv);
    creator.create();
} else if (argv._[0] === 'eslint') {
    const eslintUpgrader = new EslintUpgrader();
    eslintUpgrader.upgrade(argv.debug);
} else if ((argv._[0] === 'angular15Upgrade')) {
    const angular15 = new Angular15Upgrader();
    console.log('Passed in parameters: ' + argv.pipeline + ' ' + argv.stage + ' ' + argv.internal + ' ' + argv.debug);
    angular15.upgrade(argv.pipeline, argv.stage, argv.internal, argv.debug);
} else {
    console.log('unrecognized command: ' + argv._);
}
